import { DRAG_TYPES } from '../constants/dnd';
import { getPegboardElementComputedSpanning, getPegboardItemDimension, getPegboardItemOffset } from '../geometry/pegboard';
const DEFAULT_COLUMNS_SPANNED = 4;
const DEFAULT_ROWS_SPANNED = 2;
export function isExistingItemDragItem(dragItem) {
  return dragItem.type === DRAG_TYPES.EXISTING_ITEM ||
  // @ts-expect-error - dragType is a fallback for CEUI, and won't be needed in Editor 2.0
  dragItem.dragType === DRAG_TYPES.EXISTING_ITEM;
}
export function getDropTargetIndexWithinPegboardBounds(hoveredIndex, hoveredSize, pegboardSize) {
  const hoveredIndexAtLeastOne = Math.max(hoveredIndex, 1);
  const dropTargetIndexWithinPegboardBounds = Math.min(hoveredIndexAtLeastOne, pegboardSize - hoveredSize + 1);
  return dropTargetIndexWithinPegboardBounds;
}
export function getDropTargetPositionAndBounds({
  targetRow,
  targetColumn,
  pegboardNodePosition,
  dragItemNodePosition
}) {
  const {
    top: pegboardTop,
    left: pegboardLeft,
    rowSize,
    columnSize,
    rowGap,
    columnGap
  } = pegboardNodePosition;
  const {
    height: elementHeight,
    width: elementWidth,
    rowsSpanned,
    columnsSpanned
  } = dragItemNodePosition;
  const top = pegboardTop + getPegboardItemOffset(rowSize, rowGap, targetRow);
  const left = pegboardLeft + getPegboardItemOffset(columnSize, columnGap, targetColumn);
  let spannedRows = DEFAULT_ROWS_SPANNED;
  let spannedColumns = DEFAULT_COLUMNS_SPANNED;
  if (rowsSpanned) {
    spannedRows = rowsSpanned;
  } else if (elementHeight) {
    spannedRows = getPegboardElementComputedSpanning({
      elementSize: elementHeight,
      cellSize: rowSize,
      gap: rowGap
    });
  }
  if (columnsSpanned) {
    spannedColumns = columnsSpanned;
  } else if (elementWidth) {
    spannedColumns = getPegboardElementComputedSpanning({
      elementSize: elementWidth,
      cellSize: columnSize,
      gap: columnGap
    });
  }
  const width = getPegboardItemDimension(columnSize, columnGap, spannedColumns);
  const height = getPegboardItemDimension(rowSize, rowGap, spannedRows);
  return {
    top,
    left,
    width,
    height
  };
}